import isEmpty from 'lodash/isEmpty';

const handleMobileColorSelectionBehaviour = (
    value,
    colorList,
    priceType = null,
    colorScrollLeft,
    brokenSwatch = false
) => {
    if (!__SERVER__) {
        let scrollItem;
        /* istanbul ignore next */
        if (!isEmpty(colorList)) {
            scrollItem = colorList;
        } else if (isEmpty(colorList) && !isEmpty(priceType)) {
            scrollItem = document
                .querySelector(`#option-wrapper-${priceType}`)
                .querySelector('#productOptionsColorList');
        } else {
            scrollItem = document.querySelector('#productOptionsColorList') || {};
        }
        if (scrollItem) {
            const selectedItem =
                scrollItem.querySelectorAll && scrollItem.querySelectorAll(`[data-for="${value}"]`);
            const elOffset = brokenSwatch
                ? selectedItem && selectedItem[0]?.offsetParent?.offsetLeft
                : selectedItem && selectedItem[0]?.offsetLeft;
            const elWidth = brokenSwatch
                ? selectedItem && selectedItem[0]?.offsetParent?.offsetWidth
                : selectedItem && selectedItem[0]?.offsetWidth;
            const colorWidth = scrollItem?.offsetWidth;
            const myScrollPos = elOffset + elWidth / 2 + colorScrollLeft - colorWidth / 2;
            scrollItem.scrollLeft = myScrollPos;
        }
    }
    return true;
};

export const shouldRenderMobileView = (screenWidth) => screenWidth <= 767;

export default handleMobileColorSelectionBehaviour;
